import { FormFieldHOC } from '../HOCs';
import { AdditionalCoverageList as _AdditionalCoverageList } from './List';

export type { AdditionalCoverageListProps } from './List';
export const AdditionalCoverageList = FormFieldHOC(
  _AdditionalCoverageList as any,
);

/// TEST TEST TES
